import axios from '__js__/axios';
import reverse from 'django-reverse';
import URLS from './URLS';
import { AxiosResponse } from 'axios';

export default async ({ cardId, mapTranslateId }: { cardId: string, mapTranslateId: string }): Promise<AxiosResponse> => {
	return await axios.delete(reverse(URLS.CARD_SOFT_DELETE, mapTranslateId, cardId));
}
